import { gsap, ScrollTrigger } from "gsap/all";

export function mask() {
  gsap.registerPlugin(ScrollTrigger);
  const animationDuration = 0.4;
  const startPosition = "top 80%";
  let animationDelay = 0;
  const ease = "power2.out";

  // Reset stagger delay inside each block
  const blocks = document.querySelectorAll(".gutenberg-content > .gutenberg-block");

  blocks.forEach((block) => {
    const maskXElements = block.querySelectorAll(".animation-mask-x");

    maskXElements.forEach((element) => {
      animationDelay = element.dataset.delay ? parseFloat(element.dataset.delay) : animationDelay;

      gsap.from(element, {
        width: 0,
        duration: animationDuration,
        delay: animationDelay,
        ease: ease,
        scrollTrigger: {
          trigger: element,
          start: startPosition,
          // markers: true,
        }
      });
    });
  });
}